import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import {Screen, Select, Button, Message, Checkbox, Input} from '../components';
import {setUser} from '../actions';
import {__, toNumber, request, formatAmount, getCurrency, getUrl, getAiModels, getAiFileTools} from '../functions';
import {AI_ADDON_NAMES, AI_EXTENSIONS_NOT_FILE_SEARCH, AI_TYPE_SETTINGS, AI_TYPES, FILES_NAMES} from '../config';
import '../assets/styles/ai-addon.css';
import {Autocomplete, ButtonBase, Chip, IconButton, Slider, TextField, Tooltip} from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CopyIcon from "@mui/icons-material/ContentCopy";
import ComputerIcon from "@mui/icons-material/Computer";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import DeleteIcon from "@mui/icons-material/Delete";

/**
 * AI addon.
 */
class AiAddonScreen extends Screen {
    title = __('AI doplnok');

    state = {
        id: '',
        data: {},
        settings: {},
        chatbot_type: '',
        chatbot_settings: {},
        chatbot_files: {},
        loading: false,
        loadingRemove: false,
        loadingGenerateRelated: false,
        loadingGenerateSynonyms: false,
        relatedProducts: {},
        searchRequests: 10000,
        version: 'pc',
        lightbox: {
            delete: false,
            synonyms: false,
        },
    };

    async componentDidMount() {
        if (super.componentDidMount()) {
            const { params, setUser } = this.props;

            await request(`/ai-addons/view/${params.slug}`).then(response => {
                const { status, data, sync } = response.data;

                if (status === 'error') {
                    window.location = '/ai-addons';
                    return;
                }

                setUser(sync.user);

                let settings = data.settings;
                let chatbot_settings = {};
                let chatbot_files = {};
                let chatbot_type = '';

                if (_.has(data, 'chatbot_settings')) {
                    chatbot_settings = data.chatbot_settings;

                    _.each(data.chatbot_files, ({ file_id, tool }) => {
                        chatbot_files = { ...chatbot_files, [file_id]: tool };
                    });

                    _.each(AI_TYPE_SETTINGS, ({ temperature, top_p }, key) => {
                        if (temperature === chatbot_settings.temperature && top_p === chatbot_settings.top_p) {
                            // Has predefined setting
                            chatbot_type = key;
                        }
                    });
                }

                this.setState({
                    id: data.id,
                    data,
                    settings,
                    chatbot_settings,
                    chatbot_files,
                    chatbot_type,
                });
            });

            if (params.slug === 'related_products') {
                this.generateRelated();
            }
        }

        return true;
    }

    confirmGenerateSynonyms() {
        this.showLightbox('synonyms', {});
    }

    async generateSynonyms() {
        this.closeLightbox('synonyms');

        this.setState({ loadingGenerateSynonyms: true });

        let valid = false;

        await request('/ai-addons/generateSynonyms').then(response => {
            const { status } = response.data;

            if (status === 'error') {
                this.showSnackbar('error', __('Nemáte dostatok kreditu'));
                return;
            }

            valid = true;
        });

        if (!valid) {
            this.setState({ loadingGenerateSynonyms: false });
            return;
        }

        request('/ai-functions/run/GenerateCategoriesSynonym', {
            input: '',
            item_type: 'manual',
            item_id: null,
            variables: {},
        }, 'POST').then(response => {
            const { status, data } = response.data;

            this.setState({ loadingGenerateSynonyms: false });

            if (status === 'error') {
                let error = data.error;

                if (error === 'Empty credit') {
                    error = __('Nemáte dostatočný kredit');
                }

                this.showSnackbar('error', `${__('Chyba')}: ${error}`);
                return;
            }

            if (_.has(data, 'processing')) {
                this.showSnackbar('success', __('Synonymá sa spracovávajú, budú dostupné o pár minút'));
                return;
            }

            this.showSnackbar('success', __('Synonymá boli vygenerované'));

            setTimeout(() => { window.location = '/ai-addons/view/search' }, 500);
        });
    }

    delete() {
        const { params } = this.props;

        if (this.isDemo()) {
            this.showSnackbar('error', __('Doplnok nie je možné deaktivovať na DEMO účte'));
            return;
        }

        this.setState({ loadingRemove: true });

        request(`/ai-addons/remove/${params.slug}`).then(response => {
            const { status } = response.data;

            this.setState({ loadingRemove: false });

            if (status === 'error') {
                this.showSnackbar('error', __('Nepodarilo sa deaktivovať doplnok'));
                return;
            }

            this.showSnackbar('success', __('Doplnok bol deaktivovaný'));

            setTimeout(() => { window.location = '/ai-addons' }, 500);
        });
    }

    save() {
        const { params } = this.props;
        let { id, settings, chatbot_settings, chatbot_files } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('Doplnok nie je možné uložiť na DEMO účte'));
            return;
        }

        let error = '';

        if (error !== '') {
            // Mame error
            this.showSnackbar('error', error);
            return;
        }

        this.setState({ loading: true });

        if (params.slug === 'chat') {
            settings = { ...settings, chatbot_settings, chatbot_files };
        }

        if (toNumber(id) > 0) {
            request(`/ai-addons/edit/${params.slug}`, { settings }, 'POST').then(response => {
                const { status } = response.data;

                this.setState({ loading: false });

                if (status === 'error') {
                    this.showSnackbar('error', __('Nepodarilo sa uložiť doplnok'));
                    return;
                }

                this.showSnackbar('success', __('Doplnok bol uložený'));

                setTimeout(() => { window.location = `/ai-addons/view/${params.slug}` }, 500);
            });

            return;
        }

        request(`/ai-addons/create/${params.slug}`, { settings }, 'POST').then(response => {
            const { status } = response.data;

            this.setState({ loading: false });

            if (status === 'error') {
                this.showSnackbar('error', __('Nepodarilo sa aktivovať doplnok'));
                return;
            }

            this.showSnackbar('success', __('Doplnok bol aktivovaný'));

            setTimeout(() => { window.location = `/ai-addons/view/${params.slug}` }, 500);
        });
    }

    onChangeSetting(type, value) {
        const { settings } = this.state;

        let additional = {};

        this.setState({ settings: { ...settings, [type]: value, ...additional } });
    }

    onChangeChatbotType(type) {
        const { chatbot_settings } = this.state;

        if (type === '') {
            this.setState({ chatbot_type: type });
            return;
        }

        this.setState({ chatbot_type: type, chatbot_settings: { ...chatbot_settings, ...AI_TYPE_SETTINGS[type] } });
    }

    onChangeChatbotSetting(type, value) {
        const { data, chatbot_settings } = this.state;

        switch (type) {
            case 'max_tokens':
                if (value !== '') {
                    const max = toNumber(data.max_tokens);

                    value = toNumber(value);
                    value = value < 1 ? 1 : value;
                    value = value >= max ? max : value;
                    value = value.toString();
                }
                break;
        }

        let additional = {};

        this.setState({ chatbot_settings: { ...chatbot_settings, [type]: value, ...additional } });
    }

    notAllowFileSearch(id) {
        const { data } = this.state;

        return _.has(data.file_extensions, id) && _.includes(AI_EXTENSIONS_NOT_FILE_SEARCH, data.file_extensions[id]);
    }

    addChatbotFile(id) {
        const { data, chatbot_files } = this.state;

        let file_tool = data.default_file_tool;

        if (this.notAllowFileSearch(id)) {
            file_tool = 'code_interpreter';
        }

        this.setState({ chatbot_files: { ...chatbot_files, [id]: file_tool } });
    }

    onChangeChatbotFile(id, tool) {
        const { chatbot_files } = this.state;

        this.setState({ chatbot_files: { ...chatbot_files, [id]: tool } });
    }

    removeChatbotFile(id) {
        let { chatbot_files } = this.state;

        chatbot_files = _.omit(chatbot_files, [id]);

        this.setState({ chatbot_files });
    }

    addRelatedProductsCategory(id) {
        const { settings } = this.state;

        let categories = settings.categories;

        if (!_.includes(categories, id)) {
            categories = [ ...categories, id ];
        }

        this.onChangeSetting('categories', categories);
    }

    deleteRelatedProductsCategory(id) {
        const { settings } = this.state;

        const categories = _.reduce(settings.categories, (result, category_id) => {
            if (_.toString(id) === _.toString(category_id)) {
                return result;
            }

            return [ ...result, category_id ];
        }, []);

        this.onChangeSetting('categories', categories);
    }

    generateRelated() {
        const { settings } = this.state;

        this.setState({ loadingGenerateRelated: true });

        request('/ai-addons/showRelatedProducts', { settings }, 'POST').then(response => {
            const { status, data } = response.data;

            this.setState({ loadingGenerateRelated: false });

            if (status === 'error') {
                this.showSnackbar('error', __('Nepodarilo sa vygenerovať produkty'));
                return;
            }

            this.setState({ relatedProducts: data });
        });
    }

    changeVersion(version) {
        this.setState({ version });
    }

    copyCode(code) {
        // Nastavime placeholder do clipboardu
        navigator.clipboard.writeText(code);

        this.showSnackbar('success', __('Skopirované do schránky'));
    }

    renderRelatedProduct(product) {
        const name = _.has(product, 'translations') && _.has(product.translations, 'name')
            ? product.translations.name
            : '-';

        const number = _.has(product, 'number') && product.number !== '' ? product.number : '-';
        const ean = _.has(product, 'ean') && product.ean !== '' ? product.ean : '-';

        return (
            <div className="ai-addon__content__panels__panel__related__product">
                <div className="ai-addon__content__panels__panel__related__product__photo">
                    {_.has(product, 'img_url') && !_.isEmpty(product.img_url) ? <img src={product.img_url} /> : null}
                </div>
                <div className="ai-addon__content__panels__panel__related__product__info">
                    <div className="ai-addon__content__panels__panel__related__product__info__title">{name}</div>
                    <div className="ai-addon__content__panels__panel__related__product__info__values">{`${__('Číslo produktu')}: ${number}`}</div>
                    <div className="ai-addon__content__panels__panel__related__product__info__values">{`${__('EAN')}: ${ean}`}</div>
                </div>
            </div>
        );
    }

    renderAddon() {
        const { params } = this.props;
        const { id, data, loading, settings, version } = this.state;

        const isEdit = toNumber(id) > 0;
        let isDisabled = toNumber(data.products) === 0;

        if (params.slug === 'chat') {
            isDisabled = false;
        }

        const buttons = (
            <>
                {isEdit ? <Button
                    onClick={() => this.save()}
                    loading={loading}
                    className="ai-addon__content__button"
                    color="primary"
                    disabled={isDisabled}
                >{__('Uložiť')}</Button> : <Button
                    onClick={() => this.save()}
                    loading={loading}
                    className="ai-addon__content__button"
                    color="green"
                    disabled={isDisabled}
                >{__('Aktivovať')}</Button>}
            </>
        );

        let allowed_eshop = false;
        let code = '';

        switch (params.slug) {
            case 'chat':
                const { chatbot_type, chatbot_settings, chatbot_files } = this.state;

                allowed_eshop = data.allowed_eshop;
                code = allowed_eshop ? `<script src="${getUrl()}/chat/${data.token}/main.js?v=${data.version}"></script>` : '';

                // Remove selected files
                const allFiles = _.omit(data.files, _.keys(chatbot_files));

                const models = getAiModels(data.models);
                const fileTools = getAiFileTools(data.file_tools);

                return (
                    <>
                        {!allowed_eshop ? <Message type="warning">{__('AI chatbot pre váš eshopový systém nepodporujeme, prosím kontaktujte nás.')}</Message> : null}
                        <div className="ai-addon__content">
                            <div className="ai-addon__content__panels">
                                <div className="ai-addon__content__panels__panel">
                                    <div className="ai-addon__content__panels__panel__title">{__('Nastavenia')}</div>
                                    <Select
                                        label={__('Jazyk')}
                                        onChange={value => this.onChangeSetting('country', value)}
                                        options={_.reduce(data.countries, (result, country) => { return { ...result, [country]: country }; }, {})}
                                        value={settings.country}
                                        allowEmpty={false}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Jazyk v ktorom sa bude zobrazovať chatbot.')}</div>
                                    <Input
                                        label={__('Doména')}
                                        value={settings.url}
                                        onChange={value => this.onChangeSetting('url', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Doména eshopu (príklad mojeshop.com). Slúži na kontrolu. Zadáva sa bez https:// a www.')}</div>
                                    <Checkbox
                                        label={__('Informácie o produktoch')}
                                        value={settings.products}
                                        onChange={checked => this.onChangeSetting('products', checked)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Má mať chatbot prístup k dátam vašich produktov v eshope? Ide o verejne prístupné údaje z vášho eshopu (názov, url odkaz, číslo produktu, EAN, predajná cena). Čím viac dát má chatbot k dispozícii tým je vyššia cena.')}</div>
                                    <Input
                                        label={__('Url adresa eshopu')}
                                        value={settings.eshop_url}
                                        onChange={value => this.onChangeSetting('eshop_url', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Url adresa vášho eshopu (príklad https://www.mojeshop.com).')}</div>
                                    <Input
                                        label={__('Meno chatbota')}
                                        value={settings.name}
                                        onChange={value => this.onChangeSetting('name', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Verejné meno chatbota.')}</div>
                                    <Input
                                        label={__('Kontaktný email')}
                                        value={settings.contact_email}
                                        onChange={value => this.onChangeSetting('contact_email', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Email ktorý sa zobrazí zákazníkovi keď bude chat offline alebo nedostupný.')}</div>
                                    <Input
                                        label={__('Email')}
                                        value={settings.email}
                                        onChange={value => this.onChangeSetting('email', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Email na ktorý prepošleme celú konverzáciu po skončení chatu.')}</div>
                                    <Input
                                        label={__('Zdržanie odpovede (v sekundách)')}
                                        value={settings.delay}
                                        onChange={value => this.onChangeSetting('delay', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Počet sekúnd o koľko chatbot zdrží odpoveď pre zákazníka. Slúži k zamedzeniu spamovania chatbota zo strany zákazníka. Minimálne 1s.')}</div>
                                    <Input
                                        label={__('Počet správ v pamäti')}
                                        value={settings.last_messages}
                                        onChange={value => this.onChangeSetting('last_messages', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Koľko posledných správ si má chatbot pamätať v rámci jedného chatu. Čím viac správ si chatbot pamätá v rámci jedného chatu, tým je jeho daľšia odpoveď drahšia. Minimálne 5 správ.')}</div>
                                    <Input
                                        label={__('Maximálny počet aktívnych konverzácii')}
                                        value={settings.max_threads}
                                        onChange={value => this.onChangeSetting('max_threads', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Maximálny počet konverzácii chatbota v jednom momente. Po vyčerpaní tohto limitu sa chat zobrazí ako offline. Minimálne 1ks.')}</div>
                                    <Input
                                        label={__('Farba')}
                                        value={settings.color}
                                        onChange={value => this.onChangeSetting('color', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Farba tlačidiel vo formáte HEX kódu.')}</div>
                                    <Input
                                        label={__('Maximálny počet tokenov pre odpoveď')}
                                        value={chatbot_settings.max_tokens}
                                        onChange={value => this.onChangeChatbotSetting('max_tokens', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Čím väčší počet, tým je odpoveď od AI dlhšia, komplexnejšia a drahšia. Maximálne {COUNT}.').replace('{COUNT}', data.max_tokens)}</div>
                                </div>
                                <div className="ai-addon__content__panels__panel">
                                    {data.token !== '' && allowed_eshop ? <Message type="warning">{__('Vložte tento kód do zdrojového kódu vašej web stránky, alebo poproste vášho web administrátora, aby to spravil.')}</Message> : null}
                                    {data.token !== '' && allowed_eshop ? <div className="ai-addon__content__panels__panel__code">
                                        <Input
                                            value={code}
                                            multiline
                                        />
                                        <Tooltip title={__('Skopírovať')}>
                                            <IconButton onClick={() => this.copyCode(code)}>
                                                <CopyIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </div> : null}
                                    <div className="ai-addon__content__panels__panel__title">{__('Podklady')}</div>
                                    <Input
                                        label={__('Inštrukcie')}
                                        value={chatbot_settings.instructions}
                                        onChange={value => this.onChangeChatbotSetting('instructions', value)}
                                        multiline
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Vaše doplňujúce inštrukcie pre AI.')}</div>
                                    <div className="input">
                                        <div className="input__label">{__('Databáza otázok a odpovedí')}</div>
                                        <Button
                                            onClick={() => this.redirect('/ai-chatbot/questions')}
                                            className="ai-addon__content__panels__panel__questions-button"
                                            disabled={!isEdit}
                                        >{__('Prejsť na databázu')}</Button>
                                        <div className="ai-addon__content__panels__panel__info">{__('Znalosti AI viete rozšíriť aj vlastnou databázou otázok a odpovedí. Naučte AI na konkrétných príkladoch otázok vašich zákazníkov a vašich najčastejších odpovedí.')}</div>
                                    </div>
                                    <Select
                                        label={__('Model')}
                                        value={chatbot_settings.model}
                                        options={models}
                                        onChange={value => this.onChangeChatbotSetting('model', value)}
                                        allowEmpty={false}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Voľba modelu ovplyvňuje kvalitu výstupov aj výslednu cenu.')}</div>
                                    {chatbot_type !== '' ? <Select
                                        label={__('Osobnosť')}
                                        value={chatbot_type}
                                        options={AI_TYPES}
                                        onChange={value => this.onChangeChatbotType(value)}
                                        allowEmpty={false}
                                    /> : null}
                                    {chatbot_type !== '' ? <div className="ai-addon__content__panels__panel__info">{__('Osobnosť ktorú určíte AI. Na základe osobnosti sa menia aj výstupy.')}</div> : null}
                                    {chatbot_type !== '' ? <ButtonBase
                                        onClick={() => this.onChangeChatbotType('')}
                                        className="ai-addon__content__panels__panel__button-settings"
                                    >{__('Zadať vlastnú osobnosť')}</ButtonBase> : null}
                                    {chatbot_type === '' ? <div className="input">
                                        <div className="input__label slider__label">Temperature</div>
                                        <Slider
                                            onChange={(event, value) => this.onChangeChatbotSetting('temperature', value)}
                                            value={chatbot_settings.temperature}
                                            valueLabelDisplay="auto"
                                            min={0}
                                            max={2}
                                            step={0.05}
                                        />
                                    </div> : null}
                                    {chatbot_type === '' ? <div className="ai-addon__content__panels__panel__info">{__('Ovláda kreativitu odpovedí. Nižšia hodnota = konzistentnejšie odpovede, vyššia = kreatívnejšie.')}</div> : null}
                                    {chatbot_type === '' ? <div className="input">
                                        <div className="input__label slider__label">{__('Rozmanitosť výstupu')}</div>
                                        <Slider
                                            onChange={(event, value) => this.onChangeChatbotSetting('top_p', value)}
                                            value={chatbot_settings.top_p}
                                            valueLabelDisplay="auto"
                                            min={0}
                                            max={1}
                                            step={0.05}
                                        />
                                    </div> : null}
                                    {chatbot_type === '' ? <div className="ai-addon__content__panels__panel__info">{__('Alternatíva ku temperature, ovláda diverzitu výstupu.')}</div> : null}
                                    <div className="ai-addon__content__panels__panel__files">
                                        <div className="ai-addon__content__panels__panel__title">{__('Prílohy')}</div>
                                        <div className="ai-addon__content__panels__panel__files__list">
                                            {_.map(chatbot_files, (file_tool, file_id) => {
                                                if (!_.has(data.files, file_id)) {
                                                    return null;
                                                }

                                                let extension = null;
                                                let price = null;

                                                _.each(data.chatbot_files, chatbot_file => {
                                                    if (toNumber(chatbot_file.file_id) === toNumber(file_id)) {
                                                        extension = chatbot_file._matchingData.Files.extension;
                                                        price = chatbot_file.price;
                                                    }
                                                });

                                                const file_name = data.files[file_id];

                                                return (
                                                    <div className="ai-addon__content__panels__panel__files__list__item" key={file_id}>
                                                        <div className="ai-addon__content__panels__panel__files__list__item__left">
                                                            <div className="ai-addon__content__panels__panel__files__list__item__left__name">{_.truncate(file_name, { length: 16 })}</div>
                                                            {extension !== null ? <div className="ai-addon__content__panels__panel__files__list__item__left__extension">{extension}</div> : null}
                                                            <Select
                                                                value={file_tool}
                                                                options={fileTools}
                                                                onChange={value => this.onChangeChatbotFile(file_id, value)}
                                                                allowEmpty={false}
                                                                disabled={this.notAllowFileSearch(file_id)}
                                                            />
                                                        </div>
                                                        <div className="ai-addon__content__panels__panel__files__list__item__right">
                                                            {price !== null ? <div className="ai-addon__content__panels__panel__files__list__item__right__price">
                                                                <span>{__('Cena')}:</span>
                                                                <span>{formatAmount(price, getCurrency(), 8)}</span>
                                                            </div> : null}
                                                            <Tooltip title={__('Zmazať')}>
                                                                <IconButton onClick={() => this.removeChatbotFile(file_id)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <Select
                                            label={__('Pridať prílohu z úložiska')}
                                            options={allFiles}
                                            onChange={value => this.addChatbotFile(value)}
                                        />
                                    </div>
                                    <Message type="info" className="ai-addon__content__panels__panel__info-message">{__('Aktuálný chatbot sa zobrazí po uložení.')}</Message>
                                    {data.token !== '' ? <div className="ai-addon__content__panels__panel__buttons">
                                        <Tooltip title={__('Desktop verzia')}>
                                            <IconButton onClick={() => this.changeVersion('pc')} className={version === 'pc' ? 'active' : ''}>
                                                <ComputerIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={__('Mobilná verzia')}>
                                            <IconButton onClick={() => this.changeVersion('mobile')} className={version === 'mobile' ? 'active' : ''}>
                                                <PhoneIphoneIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </div> : null}
                                    <div className={`ai-addon__content__panels__panel__search ${version}`}>
                                        {data.token !== '' ? <iframe src={`${getUrl()}/chat.php?token=${data.token}`} /> : null}
                                    </div>
                                </div>
                            </div>
                            {buttons}
                        </div>
                    </>
                );

            case 'search':
                const { searchRequests, loadingGenerateSynonyms } = this.state;

                allowed_eshop = data.allowed_eshop;
                code = allowed_eshop ? `<script src="${getUrl()}/search/${data.token}/main.js?v=${data.version}"></script>` : '';

                return (
                    <>
                        {!allowed_eshop ? <Message type="warning">{__('AI vyhľadávanie pre váš eshopový systém nepodporujeme, prosím kontaktujte nás.')}</Message> : null}
                        {isDisabled ? <Message type="warning">{__('Nemáte žiadne produkty.')}</Message> : null}
                        <div className="ai-addon__content">
                            <div className="ai-addon__content__panels">
                                <div className="ai-addon__content__panels__panel">
                                    <div className="ai-addon__content__panels__panel__title">{__('Nastavenia')}</div>
                                    <Select
                                        label={__('Jazyk')}
                                        onChange={value => this.onChangeSetting('country', value)}
                                        options={_.reduce(data.countries, (result, country) => { return { ...result, [country]: country }; }, {})}
                                        value={settings.country}
                                        allowEmpty={false}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Jazyk v ktorom sa bude zobrazovať vyhľadávanie.')}</div>
                                    <Input
                                        label={__('Doména')}
                                        value={settings.url}
                                        onChange={value => this.onChangeSetting('url', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Doména eshopu (príklad mojeshop.com). Slúži na kontrolu. Zadáva sa bez https:// a www.')}</div>
                                    <Input
                                        label={__('Farba')}
                                        value={settings.color}
                                        onChange={value => this.onChangeSetting('color', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Farba tlačidiel vo formáte HEX kódu.')}</div>
                                    <Input
                                        label={__('Logo')}
                                        value={settings.logo}
                                        onChange={value => this.onChangeSetting('logo', value)}
                                    />
                                    <div className="ai-addon__content__panels__panel__info">{__('Logo eshopu v záhlaví vyhľadávania. Url odkaz na .jpg, .png.')}</div>
                                    <div className="ai-addon__content__panels__panel__price">
                                        <div className="input__label">{__('Informatívna kalkulačka')}</div>
                                        <Slider
                                            onChange={(event, value) => this.setState({ searchRequests: value })}
                                            value={searchRequests}
                                            valueLabelDisplay="auto"
                                            min={0}
                                            max={50000}
                                            step={100}
                                        />
                                        <div className="ai-addon__content__panels__panel__price__value">
                                            <span>{__('Cena za jedno vyhľadávanie')}:</span>
                                            <span className="green">{formatAmount(data.price, getCurrency(), 4)}</span>
                                        </div>
                                        <div className="ai-addon__content__panels__panel__price__value">
                                            <span>{__('Celková cena')}:</span>
                                            <span className="green">{formatAmount(data.price * searchRequests, getCurrency(), 4)}</span>
                                        </div>
                                    </div>
                                    <div className="ai-addon__content__panels__panel__info">{__('Každé vyhľadávanie bude automaticky odpočítané z kreditu.')}</div>
                                </div>
                                <div className="ai-addon__content__panels__panel">
                                    {data.token !== '' && allowed_eshop ? <Message type="warning">{__('Vložte tento kód do zdrojového kódu vašej web stránky, alebo poproste vášho web administrátora, aby to spravil.')}</Message> : null}
                                    {data.token !== '' && allowed_eshop ? <div className="ai-addon__content__panels__panel__code">
                                        <Input
                                            value={code}
                                            multiline
                                        />
                                        <Tooltip title={__('Skopírovať')}>
                                            <IconButton onClick={() => this.copyCode(code)}>
                                                <CopyIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </div> : null}
                                    {data.generate_synonyms_price !== '' ? <div className="input ai-addon__content__panels__panel__synonyms">
                                        <div className="input__label">{__('Databáza synoným')}</div>
                                        <div className="ai-addon__content__panels__panel__synonyms__price">{__('Cena')}: {formatAmount(data.generate_synonyms_price, getCurrency(), 8)}</div>
                                        <Button
                                            onClick={() => this.confirmGenerateSynonyms()}
                                            className="ai-addon__content__panels__panel__synonyms-button"
                                            disabled={!isEdit}
                                            loading={loadingGenerateSynonyms}
                                            color={data.generate_synonyms_count > 0 ? 'green' : 'primary'}
                                        >{data.generate_synonyms_count > 0 ? __('Vygenerované') : __('Vygenerovať synonymá')}</Button>
                                        <div className="ai-addon__content__panels__panel__info">{__('Jednorázové vygenerovanie synoným cez AI k produktom. Zlepší výsledky vyhľadávania.')}</div>
                                    </div> : null}
                                    <Message type="info">{__('Aktuálne vyhľadávanie sa zobrazí po uložení.')}</Message>
                                    {data.token !== '' ? <div className="ai-addon__content__panels__panel__buttons">
                                        <Tooltip title={__('Desktop verzia')}>
                                            <IconButton onClick={() => this.changeVersion('pc')} className={version === 'pc' ? 'active' : ''}>
                                                <ComputerIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={__('Mobilná verzia')}>
                                            <IconButton onClick={() => this.changeVersion('mobile')} className={version === 'mobile' ? 'active' : ''}>
                                                <PhoneIphoneIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </div> : null}
                                    <div className={`ai-addon__content__panels__panel__search ${version}`}>
                                        {data.token !== '' ? <iframe src={`${getUrl()}/search.php?token=${data.token}&preview_hash=${data.preview_hash}`} /> : null}
                                    </div>
                                </div>
                            </div>
                            {buttons}
                        </div>
                    </>
                );

            case 'related_products':
                const { loadingGenerateRelated, relatedProducts } = this.state;

                return (
                    <div className="ai-addon__content">
                        <div className="ai-addon__content__panels">
                            <div className="ai-addon__content__panels__panel">
                                <div className="ai-addon__content__panels__panel__title">{__('Nastavenia')}</div>
                                <Message type="warning">{__('AI k vyhodnoteniu používa objednávky za posledného pol roka. Ak nemáte v našom systéme naimportované objednávky za toto obdobie, tak nás prosím kontaktujte o doimportovanie. Čím viac objednávok tým lepší výstup od AI.')}</Message>
                                <Select
                                    label={__('Opakovanie')}
                                    onChange={value => this.onChangeSetting('period', value)}
                                    options={{
                                        '7': __('Každých 7 dní'),
                                        '14': __('Každých 14 dní'),
                                        '30': __('Každých 30 dní'),
                                    }}
                                    value={settings.period}
                                    allowEmpty={false}
                                />
                                <div className="ai-addon__content__panels__panel__info">{__('Ako často chcete aktualizovať produkty v eshope.')}</div>
                                <Input
                                    label={__('Kategórie')}
                                    content={<Autocomplete
                                        options={_.reduce(data.categories, (result, name, id) => { return [ ...result, { id, name } ]; }, [])}
                                        getOptionLabel={option => option.name}
                                        onChange={(event, value) => {
                                            if (value !== null) {
                                                this.addRelatedProductsCategory(value.id);
                                            }
                                        }}
                                        renderInput={(params) => <TextField
                                            { ...params }
                                            placeholder={__('Začnite písať názov...')}
                                            variant="outlined"
                                        />}
                                        noOptionsText={__('Nenašla sa žiadna kategória')}
                                        clearText={__('Zrušiť')}
                                    />}
                                />
                                {!_.isEmpty(settings.categories) ? <div className="ai-addon__content__panels__panel__tags">{_.map(settings.categories, category_id => {
                                    if (_.has(data.categories, 'categories')) {
                                        return null;
                                    }

                                    return <Chip
                                        onDelete={() => this.deleteRelatedProductsCategory(category_id)}
                                        label={data.categories[category_id]}
                                        key={category_id}
                                        style={{ marginRight: '4px', marginBottom: '4px' }}
                                    />;
                                })}</div> : null}
                                <div className="ai-addon__content__panels__panel__info">{__('Ak chcete špecifikovať konkrétne kategórie s ktorými má AI pracovať a ku ktorým má aktualizovať podobné produkty v eshope. Pre prvotné otestovanie môžete vyskúšať na jednej kategórii v eshope.')}</div>
                                <Checkbox
                                    label={__('Spoločné kategórie')}
                                    value={settings.same_categories}
                                    onChange={checked => this.onChangeSetting('same_categories', checked)}
                                />
                                <div className="ai-addon__content__panels__panel__info">{__('Majú mať podobné produkty spoločné kategórie s hlavným produktom? Ak nie je nastavenie aktívne AI vyberá produkty naprieč kategóriami v eshope.')}</div>
                                <Checkbox
                                    label={__('Vyžadovať spoločný nákup')}
                                    value={settings.only_co_purchase}
                                    onChange={checked => this.onChangeSetting('only_co_purchase', checked)}
                                />
                                <div className="ai-addon__content__panels__panel__info">{__('Budú sa aktualizovať iba produkty pre ktoré sú dostupné dáta z objednávok a spoločných nákupov. K produktom môže byť vygenerovaný menší počet súvisiacich produktov ako je limit. Ak je nastavenie vypnuté, vždy sa k produktom vygenerujú podobné produkty v rámci limitu na základe podobností a predaju v eshope.')}</div>
                                <Input
                                    label={__('Maximálny limit')}
                                    value={settings.limit}
                                    onChange={value => this.onChangeSetting('limit', value)}
                                />
                                <div className="ai-addon__content__panels__panel__info">{__('Maximálny počet podobných produktoch vygenerovaných cez AI. Minimálne 1ks a maximálne 10ks.')}</div>
                                <div className="ai-addon__content__panels__panel__price">
                                    <div className="input__label">{__('Nacenenie')}</div>
                                    <div className="ai-addon__content__panels__panel__price__value">
                                        <span>{__('Počet produktov')}:</span>
                                        <span>{data.products}</span>
                                    </div>
                                    <div className="ai-addon__content__panels__panel__price__value">
                                        <span>{__('Cena za produkt')}:</span>
                                        <span className="green">{formatAmount(data.price, getCurrency(), 4)}</span>
                                    </div>
                                    <div className="ai-addon__content__panels__panel__price__value">
                                        <span>{__('Celková cena')}:</span>
                                        <span className="green">{formatAmount(data.price * data.products, getCurrency(), 4)}</span>
                                    </div>
                                </div>
                                <div className="ai-addon__content__panels__panel__info">{__('Celková cena bude automaticky odpočítaná z kreditu za každé opakovanie. Ak určíte konkrétne kategórie s ktorými má AI pracovať, tak po uložení sa aktualizuje počet produktov aj výsledna cena.')}</div>
                            </div>
                            {!isDisabled ? <div className="ai-addon__content__panels__panel">
                                <Message type="info">{__('Nižšie si môžete načítať náhodný produkt z eshopu ku ktorému AI zaradí podobné produkty. Slúži pre otestovanie funkcionality zadarmo.')}</Message>
                                {!_.isEmpty(relatedProducts) && _.has(relatedProducts, 'product') ? <div className="ai-addon__content__panels__panel__related">
                                    <div className="ai-addon__content__panels__panel__related__main">
                                        <div className="ai-addon__content__panels__panel__related__main__title">{__('Hlavný produkt')}</div>
                                        {this.renderRelatedProduct(relatedProducts.product)}
                                    </div>
                                    <div className="ai-addon__content__panels__panel__related__childs">
                                        <div className="ai-addon__content__panels__panel__related__childs__title">{__('Podobné produkty')}</div>
                                        {_.has(relatedProducts, 'childs') ? _.map(relatedProducts.childs, child => this.renderRelatedProduct(child)) : null}
                                    </div>
                                </div> : null}
                                <Button
                                    onClick={() => this.generateRelated()}
                                    loading={loadingGenerateRelated}
                                    className="ai-addon__content__button"
                                    color="shadow"
                                >{__('Generovať znova')}</Button>
                            </div> : <div className="ai-addon__content__panels__panel"><Message type="warning">{__('Nemáte žiadne produkty.')}</Message></div>}
                        </div>
                        {buttons}
                    </div>
                );
        }

        return null;
    }

    /**
     * Rendrovanie.
     *
     * @returns {JSX.Element}
     */
    render() {
        const { params } = this.props;
        const { id, data, loadingRemove } = this.state;

        if (_.isEmpty(data)) {
            // Data nie su nacitane
            return this.renderLoading();
        }

        if (!this.hasPermission('aiaddons')) {
            // Nema pravo
            return null;
        }

        const isEdit = toNumber(id) > 0;

        return (
            <div className="ai-addon">
                <div className="ai-addon__header">
                    <div className="ai-addon__header__left">
                        <div className="ai-addon__header__left__title">{AI_ADDON_NAMES[params.slug]}</div>
                        <div className="ai-addon__header__left__tags">
                            <Chip
                                onClick={() => {}}
                                color="secondary"
                                label={`${__('Aktuálny kredit')}: ${formatAmount(data.credit, getCurrency(), 4)}`}
                                icon={<MonetizationOnIcon />}
                            />
                        </div>
                    </div>
                    <div className="ai-addon__header__right">
                        <Button
                            onClick={() => window.location = '/ai-addons'}
                            color="shadow"
                        >{__('Naspäť')}</Button>
                        {isEdit ? <Button
                            onClick={() => this.showLightbox('delete')}
                            loading={loadingRemove}
                            color="red"
                        >{__('Deaktivovať')}</Button> : null}
                    </div>
                </div>
                {this.renderAddon()}
                {this.renderLightbox(
                    'delete',
                    __('Naozaj chcete deaktivovať tento doplnok?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.delete()
                )}
                {this.renderLightbox(
                    'synonyms',
                    __('Naozaj chcete generovať synonymá k produktom?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.generateSynonyms()
                )}
                {this.renderSnackbar()}
            </div>
        );
    }
}

const stateToProps = ({ user }) => ({ user });

export default withCookies(connect(stateToProps, {
    setUser,
})(AiAddonScreen));
